export const COW_STATUS_TRANSLATIONS = {
  title: "Zrozumienie Statusu Twojego Bydła",

  howStatusUpdatesWork: {
    title: "Jak to Działa?",
    description:
      "Automatycznie śledzimy status Twojego bydła na podstawie tego, co rejestrujesz. Każdy status aktualizuje się za każdym razem, gdy zarejestrujesz odpowiednie zdarzenie.",
  },

  statusTypes: {
    title: "Rodzaje Statusów",

    healthy: {
      title: "Zdrowe",
      meaning:
        "Pokazuje, czy Twoje bydło jest obecnie w dobrym stanie zdrowia.",
      becomesTrue: "Kiedy zarejestrujesz pozytywną kontrolę zdrowia",
      becomesFalse:
        "Kiedy zarejestrujesz negatywną kontrolę zdrowia, leczenie choroby, leczenie urazu, operację, kontrolę pooperacyjną lub szczepienie",
    },

    underTreatment: {
      title: "Pod Leczeniem",
      meaning:
        "Pokazuje, czy Twoje bydło otrzymuje obecnie opiekę medyczną lub leki.",
      becomesTrue:
        "Kiedy zarejestrujesz jakąkolwiek opiekę medyczną, taką jak szczepienia, leczenie chorób, odrobaczanie, leczenie ran, operacje, kontrole pooperacyjne lub podawanie suplementów",
      becomesFalse: "Kiedy zarejestrujesz pozytywną kontrolę zdrowia",
    },

    pregnant: {
      title: "Ciężarna",
      meaning: "Pokazuje, czy Twoje bydło spodziewa się cielęcia.",
      becomesTrue: "Kiedy zarejestrujesz pozytywną kontrolę ciąży",
      becomesFalse:
        "Kiedy zarejestrujesz negatywną kontrolę ciąży, poronienie, poród, inseminację, naturalne krycie lub wykrycie rui",
    },

    inHeat: {
      title: "W Rui",
      meaning:
        "Pokazuje, czy Twoje bydło jest w cyklu rozrodczym i gotowe do krycia.",
      becomesTrue: "Kiedy zarejestrujesz wykrycie rui",
      becomesFalse:
        "Kiedy zarejestrujesz pozytywną kontrolę ciąży, inseminację lub naturalne krycie",
    },

    lactating: {
      title: "Laktujące",
      meaning: "Pokazuje, czy Twoje bydło obecnie produkuje mleko.",
      becomesTrue: "Kiedy zarejestrujesz początek laktacji",
      becomesFalse:
        "Kiedy zarejestrujesz koniec laktacji lub zaprzestanie doju",
    },
  },

  labels: {
    whatItMeans: "Co to oznacza?",
    whenItBecomesTrue: "Kiedy się aktywuje?",
    whenItBecomesFalse: "Kiedy się dezaktywuje?",
  },
}
